import {
  Button,
  Layout,
  notification,
  Skeleton,
  Space,
  theme,
  Typography,
} from "antd";
import React, { useContext, useRef, useState } from "react";
import {
  initPrestationSlice,
  setLoading,
  setPropertiesPrestation,
  updatePrestation,
} from "../Slices/Prestation.slice";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import CustomForm from "../../../shared/components/CustomForm";
import routes from "../../../engine/routes";
import { EditFilled, PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import {
  renderUserName,
  renderUserNameEmail,
  roles,
  subRoles,
} from "../../../utils/constants";
import { PrestationHeader } from "../../../shared/components/PrestationHeader/PrestationHeader";
import { CreateApplicant } from "../../../shared/components/CreateApplicant/CreateApplicant";
import { modalsByContext } from "../../../shared/components/Modals/modals";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { IoAddSharp } from "react-icons/io5";
import {
  renderAdress,
  typeAddress,
} from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { LuMapPin } from "react-icons/lu";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { GrPowerReset } from "react-icons/gr";
import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import { LiaUserTagSolid } from "react-icons/lia";

const { Content, Sider, Header, Footer } = Layout;

export function PrestationInformations({ isNew }) {
  const { id } = useParams();
  const { prestation, loading } = useSelector(state => state.prestation);
  const { intervenant, responsable } = prestation;

  const [disabled] = usePrestationDisabler();

  const { init, clear } = initPrestationSlice({ id });
  const navigate = useNavigate();

  const [change, setChange] = useState(undefined);

  const context = useContext(ModalContext);

  const dispatch = useDispatch();

  const formRef = useRef(null);

  const {
    token: { colorBgLyout },
  } = theme.useToken();

  const inputs = [
    {
      parentLabel: "",
      children: [
        {
          label: "N° de commande",
          name: "reference",
          disabled: true,
          capitalize: false,
          required: true,
          type: "input",
          variant: "important",
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Adresse de facturation",
      children: [
        {
          type: "input-hidden",
          name: "institutionBilling",
        },
        {
          label: "Adresse de facturation",
          name: "billing",
          quote: (
            <>
              <p>Vous pouvez les éditer sur la page de l'institution </p>
              <a
                target={"_blank"}
                href={
                  routes.institutions(prestation?.institution?._id).addresses
                    .path
                }
              >
                Editer les addresses
              </a>
            </>
          ),
          disabled: disabled,
          quoteIcon: "edit",
          addonBefore: <EditFilled />,
          type: "dynamic-select",
          required: true,
          value:
            prestation.billing === null
              ? prestation?.institution?.defaultAddress
              : prestation.billing._id,
          multiple: false,
          endPoint: `addresses?institution=${prestation?.institution?._id}&type=${typeAddress.postal}&availableForBilling=true`,
          updateEndPoint: [change],
          itemsCallBack: addresses => {},
          inputSize: "large",
          noSorting: true,
          onChange: ({ value, ref, dynamicSource }) => {
            ref.current.setFieldsValue({
              institutionBilling: dynamicSource.institution._id,
            });
          },
          itemCallback: adress => {
            return {
              key: adress._id,
              label: renderAdress(
                adress,
                prestation?.institution?.defaultAddress === adress._id,
                prestation?.institution,
              ),
              value: adress._id,
            };
          },
          col: 24,
        },
        {
          type: "component",
          component: ({ disabled }) => {
            return (
              <>
                {onlyRoleMapping([roles.admin, roles.permanance]) && (
                  <Button
                    disabled={disabled}
                    onClick={() => {
                      context.openModal(
                        modalsByContext.InstitutionNewAddress,
                        {
                          institution: prestation.institution?._id,
                          principal: null,
                          type: typeAddress.postal,
                        },
                        newAddress => {
                          formRef.current.setFieldsValue({
                            institutionBilling: prestation.institution?._id,
                            billing: newAddress._id,
                          });
                          setChange(Math.random());
                        },
                      );
                    }}
                    size={"small"}
                    style={{
                      justifySelf: "flex-start",
                      display: "flex",
                    }}
                    icon={
                      <IoAddSharp
                        style={{
                          marginTop: "0px",
                        }}
                        size={25}
                      />
                    }
                  >
                    Ajouter une adresse
                  </Button>
                )}
              </>
            );
          },
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Responsable de l'entretien",
      children: [
        // {
        //   label: "Intervenant (a supprimer, ancienne méthode, pour comparer)",
        //   name: "intervenant",
        //   value: intervenant?._id,
        //   type: "dynamic-select",
        //   endPoint: `/responsables?institution=${prestation.institution?._id}`,
        //   // watchRenderCondition: true,
        //   quote: (
        //     <>
        //       <p>Vous pouvez les éditer sur la page de l'institution </p>
        //       <a
        //         target={"_blank"}
        //         href={
        //           routes.institutions(prestation?.institution?._id).responsables
        //             .path
        //         }
        //       >
        //         Editer les responsables d'entretien
        //       </a>
        //     </>
        //   ),
        //   quoteIcon: "edit",
        //   addonBefore: <EditFilled />,
        //   updateEndPoint: [change],
        //   itemCallback: item => {
        //     return {
        //       key: item._id,
        //       label: renderUserNameEmail(item),
        //       value: item._id,
        //     };
        //   },
        //   col: 24,
        // },
        {
          type: "component",
          component: ({ disabled }) => {
            return (
              <>
                <Space direction={"horizontal"}>
                  <Button
                    disabled={disabled}
                    type={"primary"}
                    onClick={() => {
                      context.openModal(
                        modalsByContext.SelectResponsable,
                        {
                          institution: prestation.institution?._id,
                          formRef,
                        },
                        ({ _id, data }) => {
                          if (data) {
                            formRef.current.setFieldsValue({
                              "responsable.firstname": data.firstname,
                              "responsable.email": data.email,
                              "responsable.phone": data.phone,
                              "responsable.lastname": data.lastname,
                              "responsable.role": data.role,
                            });
                            setChange(_id);
                          }
                        },
                      );
                    }}
                    icon={
                      <UserOutlined
                        style={{
                          marginTop: "0px",
                        }}
                        size={15}
                      />
                    }
                    size={"small"}
                  >
                    Sélectionner un responsable d'entretien prédéfini
                  </Button>
                  <CreateApplicant
                    disabled={disabled}
                    institution={prestation.institution?._id}
                    key={Math.random()}
                    name={"intervenant"}
                    formRef={formRef}
                    onCreated={(_id, data) => {
                      formRef.current.setFieldsValue({
                        "responsable.firstname": data.firstname,
                        "responsable.email": data.email,
                        "responsable.phone": data.phone,
                        "responsable.lastname": data.lastname,
                        "responsable.role": data.role,
                      });
                      setChange(_id);
                    }}
                  />
                  <Button
                    disabled={disabled}
                    type={"text"}
                    onClick={() => {
                      formRef.current.setFieldsValue({
                        "responsable.firstname": "",
                        "responsable.email": "",
                        "responsable.phone": "",
                        "responsable.lastname": "",
                        "responsable.role": "",
                      });
                      setChange(null);
                    }}
                    size={"small"}
                    icon={
                      <GrPowerReset style={{ marginTop: "-3px" }} size={15} />
                    }
                  >
                    Réinitialiser
                  </Button>
                </Space>
              </>
            );
          },
          col: 24,
        },

        {
          placeholder: "Nom",
          name: "responsable.lastname",
          type: "input",
          capitalize: true,
          addonBefore: <UserOutlined />,
          col: 12,
          disabled: !userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          }),
        },
        {
          placeholder: "Prénom",
          name: "responsable.firstname",
          addonBefore: <UserOutlined />,
          capitalize: true,
          type: "input",
          col: 12,
          disabled: !userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          }),
        },

        {
          placeholder: "Téléphone",
          name: "responsable.phone",
          addonBefore: <PhoneOutlined />,
          type: "input",
          col: 12,
          disabled: !userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          }),
        },
        {
          name: "responsable.role",
          addonBefore: <LiaUserTagSolid />,
          placeholder: "Fonction",
          type: "input",
          col: 12,
          disabled: !userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          }),
        },
        {
          placeholder: "Email",
          name: "responsable.email",
          addonBefore: <HiOutlineMail />,
          type: "input",
          col: 24,
          disabled: !userHasLevel({
            not: {
              [roles.institution]: "", //
            },
          }),
        },
      ],
    },
    {
      parentLabel: "Commentaires ",
      children: [
        {
          label: "Commentaire permanence AVIC",
          name: "comment.internal",
          type: "textarea",
          rows: 4,
          col: 24,
          disabled: !userHasLevel({
            not: {
              [roles.institution]: "",
            },
          }),
        },
        {
          label: "Commentaire pour l’interprète",
          name: "comment.interprete",
          type: "textarea",
          rows: 4,
          col: 24,
        },
      ],
    },
    {
      parentLabel: "Bénéficiaire",
      description:
        "Les informations affichées ci-dessous apparaîtront dans la facture.",
      children: [
        {
          label:
            "Référence du bénéficiaire (par ex. date de naissance, numéro AVS, ...)",
          name: "beneficiary.reference",
          type: "input",
          col: 24,
        },
        {
          label: "Nom du bénéficiaire",
          name: "beneficiary.firstname",
          type: "input",
          capitalize: true,
          col: 24,
        },
        {
          label: "Prénom du bénéficiaire",
          name: "beneficiary.lastname",
          type: "input",
          capitalize: true,
          col: 24,
        },
      ],
    },

    {
      children: [
        {
          label: "Sauvegarder & suivant",
          name: "send",
          value: "send",
          type: "submit",
          loading: loading,
          col: 24,
          align: "right",
        },
      ],
    },
  ];
  const formatString = s => {
    return Number(s.replace(/[^0-9.-]+/g, ""));
  };

  function isValidBeneficiary(data) {
    const { firstname, lastname, reference } = data.beneficiary || {};

    const isValidField = field =>
      typeof field === "string" && field.trim().length >= 3;

    return (
      isValidField(firstname) ||
      isValidField(lastname) ||
      isValidField(reference)
    );
  }

  function isValidResponsable(data) {
    const { firstname, lastname, email, phone } = data.responsable || {};

    const toString = v => (v === null || v === undefined ? "" : String(v));
    const len = v => toString(v).trim().length;

    const hasName = len(firstname) >= 3 || len(lastname) >= 3;
    const hasContact = len(email) >= 3 || len(phone) >= 3;

    return hasName && hasContact;
  }

  const isAdmin = userHasLevel({
    only: {
      [roles.admin]: "crud", //
      [roles.permanance]: "crud", //
    },
  });
  const onSubmitForm = async data => {
    data.steps ??= {};
    data.steps.resume = true;

    const validBeneficiary = isValidBeneficiary(data);
    const validResponsable = isValidResponsable(data);

    if ((validBeneficiary && validResponsable) || isAdmin === true) {
      await dispatch(setLoading(true));
      await dispatch(setPropertiesPrestation(data));
      const result = await dispatch(updatePrestation("resume"));
      // the booking changed meanwhile: the page reloads instead of moving on
      if (result.payload?.stale) {
        return;
      }
      await navigate(routes.prestations(id).detailResume.path);
      await dispatch(setLoading(false));
    } else {
      await dispatch(setLoading(false));

      const errors = [];

      if (!validBeneficiary) {
        errors.push(
          {
            name: "beneficiary.firstname",
            errors: [
              "Renseignez au moins un des trois champs (min. 3 caractères).",
            ],
          },
          {
            name: "beneficiary.lastname",
            errors: [
              "Renseignez au moins un des trois champs (min. 3 caractères).",
            ],
          },
          {
            name: "beneficiary.reference",
            errors: [
              "Renseignez au moins un des trois champs (min. 3 caractères).",
            ],
          },
        );
      }

      if (!validResponsable) {
        const r = data.responsable || {};
        const toString = v => (v === null || v === undefined ? "" : String(v));
        const len = v => toString(v).trim().length;

        const hasName = len(r.firstname) >= 3 || len(r.lastname) >= 3;
        const hasContact = len(r.email) >= 3 || len(r.phone) >= 3;

        if (!hasName) {
          errors.push(
            {
              name: "responsable.firstname",
              errors: [
                "Renseignez prénom ou nom (min. 3 caractères).",
              ],
            },
            {
              name: "responsable.lastname",
              errors: [
                "Renseignez prénom ou nom (min. 3 caractères).",
              ],
            },
          );
        }

        if (!hasContact) {
          errors.push(
            {
              name: "responsable.email",
              errors: [
                "Renseignez email ou téléphone (min. 3 caractères).",
              ],
            },
            {
              name: "responsable.phone",
              errors: [
                "Renseignez email ou téléphone (min. 3 caractères).",
              ],
            },
          );
        }
      }

      formRef.current.setFields(errors);

      notification.error({
        message:
          "Bénéficiaire: ≥1 champ (min. 3). Responsable: prénom/nom ET email/téléphone.",
      });
    }
  };
  return (
    <>
      <PrestationHeader
        title={routes.prestations(id).detailInformations.title}
      />
      {loading ? (
        <Skeleton active />
      ) : (
        <>
          <CustomForm
            // a newer copy of the booking from the server replaces what the form was opened with
            key={prestation.updatedAt ?? "new"}
            disabled={disabled}
            initialValues={prestation}
            dataSource={inputs}
            handleSubmit={data => onSubmitForm(data)}
            labelCol={24}
            refForm={formRef}
            wrapperCol={24}
            onValuesChange={undefined}
          />
        </>
      )}
    </>
  );
}
